import React from 'react'
import images from '../content/images'

import './main.css'
const Main = () => {
  return (
    
      <div className='container'>
            <div className='left'>
                <div className='left_content'>
                    <h4>Your Result</h4>
                    <div className='circle'>
                        <p>76 <br/><span>of 100</span></p>
                    </div>
                    <h3>Great</h3>
                    <p>You scored higher than 65%
                         of the people who have taken these tests.</p>
                </div>
            </div>
            <div className='right'>
                <div className='right_summary'>
                    <h4>Summary</h4>
                    
                    <div className='sum_reaction'>
                    <div className='reaction'><img src={images.reaction} />Reaction</div>
                    <p className='score'><span>80&nbsp;</span>/ 100</p>
                    </div>
                    <div className='sum_memory'>
                    <div className='memory'><img src={images.memory} />Memory</div>
                    <p className='score'><span>92&nbsp;</span>/ 100</p>
                    </div>
                    <div className='sum_verbal'>
                    <div className='verbal'><img src={images.verbal} />Verbal</div>
                    <p className='score'><span>61&nbsp;</span>/ 100</p>
                    </div>
                    <div className='sum_visual'>
                    <div className='visual'><img src={images.visual} />Visual</div>
                    <p className='score'><span>72&nbsp;</span>/ 100</p>
                    </div>

                    <button>Continue</button>
                      
                </div>
            </div>
      </div>
    
  )
}

export default Main
